let currentToken: string | null = null;

const RESET_EVENT = 'nivasasaathi:turnstile-reset';

export function setTurnstileToken(token: string | null): void {
  currentToken = token;
}

export function getTurnstileToken(): string | null {
  return currentToken;
}

export function resetTurnstileToken(): void {
  currentToken = null;
  window.dispatchEvent(new Event(RESET_EVENT));
}

export function onTurnstileReset(listener: () => void): () => void {
  window.addEventListener(RESET_EVENT, listener);
  return () => window.removeEventListener(RESET_EVENT, listener);
}

export function turnstileIsConfigured(): boolean {
  return Boolean(import.meta.env.VITE_TURNSTILE_SITE_KEY?.trim());
}
